/*
* Currency tools
*
* Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
* Licensed under the MIT license:
* http://www.opensource.org/licenses/mit-license.php
*/

if (typeof Currency === "undefined") {
  var Currency = {}
}
Currency.moneyFormats = {
  USD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} USD"
  },
  EUR: {
      money_format: "&euro;{{amount}}",
      money_with_currency_format: "&euro;{{amount}} EUR"
  },
  GBP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} GBP"
  },
  // ... other currency formats
};
Currency.formatMoney = function(b, g) {
  if (typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(b, g)
  }
  if (typeof b === "string") {
      b = b.replace(".", "")
  }
  var f = "";
  var e = /\{\{\s*(\w+)\s*\}\}/;
  var a = g || "${{amount}}";

  function c(h, i) {
      return (typeof h === "undefined" ? i : h)
  }

  function d(m, k, l, j) {
      k = c(k, 2);
      l = c(l, ",");
      j = c(j, ".");
      if (isNaN(m) || m == null) {
          return 0
      }
      m = (m / 100).toFixed(k);
      var n = m.split("."),
          i = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + l),
          h = n[1] ? (j + n[1]) : "";
      return i + h
  }
  switch (a.match(e)[1]) {
      case "amount":
          f = d(b, 2);
          break;
      case "amount_no_decimals":
          f = d(b, 0);
          break;
      case "amount_with_comma_separator":
          f = d(b, 2, ".", ",");
          break;
      case "amount_no_decimals_with_comma_separator":
          f = d(b, 0, ".", ",");
          break
  }
  return a.replace(e, f)
};
Currency.currentCurrency = "";
Currency.format = "money_with_currency_format";
Currency.convertAll = function(c, b, a, d) {
  jQuery(a || "span.money").each(function() {
      if (jQuery(this).attr("data-currency") === b) {
          return
      }
      if (jQuery(this).attr("data-currency-" + b)) {
          jQuery(this).html(jQuery(this).attr("data-currency-" + b))
      } else {
          var e = 0;
          var f = Currency.moneyFormats[c][d || Currency.format] || "{{amount}}";
          var g = Currency.moneyFormats[b][d || Currency.format] || "{{amount}}";
          if (f.indexOf("amount_no_decimals") !== -1) {
              e = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ""), 10) * 100, c, b)
          } else {
              if (c === "JOD" || c == "KWD" || c == "BHD") {
                  e = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ""), 10) / 10, c, b)
              } else {
                  e = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ""), 10), c, b)
              }
          }
          var h = Currency.formatMoney(e, g);
          jQuery(this).html(h);
          jQuery(this).attr("data-currency-" + b, h)
      }
      jQuery(this).attr("data-currency", b)
  });
  this.currentCurrency = b;
};